import { useEffect, useState } from "react";

// A plain ticking clock — deliberately not built on Astryx's `Timestamp`,
// which only auto-updates *relative* labels ("2 minutes ago"); an absolute
// wall-clock time in a specific timezone needs its own interval. Used by the
// live wall's per-site status strip (each Project carries its own IANA
// timezone) and the login screen's live-clock touch.
export function useClockTick(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

// Formats `now` as a short local time in `timezone` (e.g. "14:32"). Falls
// back to an empty string for a timezone Intl doesn't recognize rather than
// throwing — defensive against stale/malformed data, not expected in
// practice since Project.timezone is validated server-side.
export function formatSiteTime(now: number, timezone: string): string {
  try {
    return new Intl.DateTimeFormat(undefined, {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
    }).format(now);
  } catch {
    return "";
  }
}
